import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllQuotes, createNewQuote, editQuote, deleteQuote } from './thunks';
import { QuotesState } from './types';

export const name = 'quotes';

const initialState: QuotesState = {
  data: [],

  status: 'idle',
  updatingStatus: 'idle',
};
export const getAllQuotesAsync = createAsyncThunk(
  name + '/getAllQuotes',
  getAllQuotes
);

export const createNewQuoteAsync = createAsyncThunk(
  name + '/createNewQuote',
  createNewQuote
);

export const editQuoteAsync = createAsyncThunk(name + '/editQuote', editQuote);

export const deleteQuoteAsync = createAsyncThunk(
  name + '/deleteQuote',
  deleteQuote
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllQuotesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllQuotesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllQuotesAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(createNewQuoteAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(createNewQuoteAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(createNewQuoteAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(editQuoteAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(editQuoteAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(editQuoteAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(deleteQuoteAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(deleteQuoteAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(deleteQuoteAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
